<template>
  <div class="app-container">
      <el-form :model="queryParams" ref="queryForm" :inline="true" style="overflow: hidden; clear: both;">
          <el-form-item label="存证标题" class="f-item">
            <el-input
              style="width: 300px;"
              v-model="queryParams.title"
              placeholder="请输入存证标题"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="hash" class="f-item">
            <el-input
              style="width: 300px;"
              v-model="queryParams.hash"
              placeholder="请输入"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="blue" size="mini" @click="handleQuery">搜索</el-button>
          </el-form-item>
        </el-form>
      
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              type="blue"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
            >公示公告</el-button>
          </el-col>
          <!-- <el-col :span="1.5">
            <el-button
              type="warning"
              icon="el-icon-download"
              size="mini"
              @click="handleExport"
            >导出</el-button>
          </el-col> -->
        </el-row>

    <el-table v-loading="loading" stripe :data="arbitrateRecords">
      <el-table-column  type="index" label="序号" width="70" align="center"/>
      <el-table-column label="公告编号" align="center" prop="code" min-width="130"/>
      <el-table-column label="存证标题" prop="title" min-width="300"/>
      <el-table-column label="hash" prop="hash" min-width="360"/>
      <el-table-column label="业务场景" align="center" prop="sceneType" :formatter="sceneTypeFormat"/>
      <el-table-column label="客户来源" align="center" prop="source" width="150" :formatter="sourceFormat"/>
      <el-table-column label="信披平台" align="center" prop="platform" width="100" :formatter="platformFormat"/>
      <el-table-column label="存证时间" prop="createTime" width="160"></el-table-column>
      <el-table-column label="操作" align="center" width="100" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <span class="f-blue" @click="preview(scope.row)">下载链证报告</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="toolbar">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum" :page-size="queryParams.pageSize" :total="total">
        </el-pagination>
    </div>

  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js' 
export default {
  name: "notice",
  components: {

  },
  data() {
    return {
      headers: {},
      loading: true,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      arbitrateRecords: [],
      open: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        userName: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        title: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        sceneType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        source: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        platform: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        remark: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
      },
      sceneOptions: [
        {
          dictLabel: "拍卖文物",
          dictValue: "01"
        },
        {
          dictLabel: "拍卖不良资产",
          dictValue: "02"
        },
        {
          dictLabel: "国有产权交易",
          dictValue: "03"
        },
        {
          dictLabel: "不良金融资产",
          dictValue: "04"
        },
        {
          dictLabel: "PPP资产交易",
          dictValue: "05"
        },
        {
          dictLabel: "破产清算",
          dictValue: "06"
        },
        {
          dictLabel: "政府采购",
          dictValue: "07"
        }
      ],
      platformOptions: [
        {
          dictLabel: "中国发展网",
          dictValue: "01"
        }
      ],
      sourceOptions: [
        {
          dictLabel: "北京拍卖行业协会",
          dictValue: "01"
        },
        {
          dictLabel: "北京天珒拍卖有限公司",
          dictValue: "02"
        },
        {
          dictLabel: "天津金融资产交易所",
          dictValue: "03"
        }
      ],
      account: sessionStorage.account,
      idNo: '',
      companyType: ''
    }
  },
  created() {
    this.getList()
    this.getInf()
  },
  methods: {
    selectDictLabel(datas, value) {
      var actions = [];
      Object.keys(datas).some((key) => {
        if (datas[key].dictValue == ('' + value)) {
          actions.push(datas[key].dictLabel);
          return true;
        }
      })
      return actions.join('');
    },
    sceneTypeFormat(row) {
      return this.selectDictLabel(this.sceneOptions, row.sceneType);
    },
    sourceFormat(row) {
      return this.selectDictLabel(this.sourceOptions, row.source);
    },
    platformFormat(row) {
      return this.selectDictLabel(this.platformOptions, row.platform);
    }, 
    getInf(){
      this.$api.api.getInfoByAccount({account: this.account}).then(response => {
        this.companyType = response.data.companyType
        this.idNo = response.data.idNo
      });
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },   
    getList() {
      this.queryParams.creator = sessionStorage.account;
      let queryParams = Object.assign({}, this.queryParams);
      this.$api.api.noticeList(queryParams).then(response => {
        this.loading = false
        if(response.code==200){
          this.arbitrateRecords = response.rows;
          this.total = response.total;
        }else {
          this.$message.error(response.msg);
        }    
      });
    },  
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery();
    },
    preview(row) {
      window.location.href = `${baseUrl.apiUrl}/iacc-notice/arbitrate/noticeReportPreview?id=${row.id}`
    },
    handleAdd(){
      if(this.companyType == '01' && (!this.idNo || this.idNo == '')){
        this.$message.error("您未实名，请前去实名！");
        this.$router.push({path: '/nUser'});        
      }else {
        this.$router.push({path: '/addNotice'});
      }
    },    
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm("确定导出此存证信息吗？", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          return this.$api.api.exportNotice(queryParams);
        }).then(response => {
          this.download(response.msg);
        })     
    }
  }
}
</script>

<style>
.wrap{word-wrap:break-word; word-break:break-all;}
</style>
